import { useState } from "react";
import { rankList } from "../../../mocks/clueSite";

const MAX = Math.max(...rankList.map((r) => r.heat));

export default function RankBoard() {
  const [mode, setMode] = useState<"all" | "surge">("all");
  const list = mode === "all" ? rankList : rankList.filter((r) => parseInt(r.trend, 10) >= 20);
  const maxHeat = mode === "all" ? MAX : Math.max(...list.map((r) => r.heat));

  return (
    <section id="rank" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex h-6 items-center rounded bg-primary-600 px-2 text-xs font-semibold text-background-50">
                实 时
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">爆料热度榜</h2>
            </div>
            <p className="mt-2 text-sm text-foreground-600">按线人围观、评论增量与核实进度综合排序，飙升项以箭头标出。</p>
          </div>
          <div className="inline-flex items-center gap-1 rounded-full bg-background-200 p-1 self-start md:self-auto">
            {[
              { k: "all" as const, label: "全量热度" },
              { k: "surge" as const, label: "仅看飙升" },
            ].map((t) => (
              <button
                key={t.k}
                onClick={() => setMode(t.k)}
                className={`rounded-full px-4 py-1.5 text-sm whitespace-nowrap ${
                  mode === t.k
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 lg:grid-cols-2 gap-3">
          {list.map((r, idx) => (
            <div
              key={r.no}
              className="row-hover lift group rounded-lg bg-background-50 p-3 md:p-4 border border-background-200/60 hover:border-primary-300"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <span
                  className={`num font-number text-3xl md:text-5xl font-extrabold leading-none ${
                    idx === 0 ? "text-primary-600" : idx === 1 ? "text-accent-600" : "text-foreground-300"
                  }`}
                >
                  {r.no}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="inline-flex items-center gap-1 rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">
                      {r.cat}
                    </span>
                    <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-accent-600">
                      <i className="ri-arrow-up-line" />
                      {r.trend}
                    </span>
                  </div>
                  <h3 className="mt-1.5 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-700 leading-snug">
                    {r.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-primary-500" />
                      <span className="font-number font-semibold">{r.heat.toLocaleString()}</span> 围观
                    </span>
                    <span className="text-background-300">·</span>
                    <span>进入核查</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-full rounded-full ${idx === 0 ? "bg-primary-500" : idx === 1 ? "bg-accent-500" : "bg-secondary-400"}`}
                      style={{ width: `${(r.heat / maxHeat) * 100}%` }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}